export function extractNumberFromString(str: string): number | null {
  const matches = str.match(/\d+/);
  if (matches) {
    return parseInt(matches[0], 10);
  }
  return null; // Return null if no number is found in the string
}
